import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '@/api/index';
import { CLIENT_URL, BASE_URL } from '@/constants/index';

export const individualApi = createApi({
  reducerPath: 'individualApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Individual'],
  endpoints: (builder) => ({
    getCountries: builder.query({
      query: ({ widgetId, id, pageType, lang }) => ({
        baseURL: CLIENT_URL,
        headers: { 'Accept-Language': lang },
        url: `roaming-search/${widgetId}/countries/${id}/${pageType}/`,
        method: 'GET',
      }),
    }),
    getContract: builder.query({
      query: ({ lang, termsType }) => ({
        url: `/prod/bakcell-terms-conditions/terms-conditions/contract?termsType=${termsType}`,
        baseURL: BASE_URL,
        headers: { 'Accept-Language': lang },
      }),
    }),
  }),
});

export const hooks = {
  useGetCountries: individualApi.useGetCountriesQuery,
  useGetContract: individualApi.useGetContractQuery,
};

export default individualApi;
